import React, { Component } from "react";

import { Grid } from "semantic-ui-react";
import { connect } from "react-redux";

import { appLoaded } from "../../actions/common.actions";
import { logOut } from "../../actions/auth.actions";
import HomeError from "./HomeError";
import HomeHeader from "./HomeHeader";
import HomeMenu from "./HomeMenu";
import "./Home.scss";

import AppRouting from "../AppRouting";
import { ToastContainer } from "react-toastify";

export class Home extends Component {
  componentWillMount() {
    this.props.loadApp();
  }

  render() {
    const { currentUser, currentTenant } = this.props;
    if (!(currentUser && currentTenant)) return <HomeError />;

    const tenantName = currentTenant && currentTenant.name.toLowerCase();

    return (
      <Grid stretched divided padded="horizontally" columns={2}>
        <Grid.Row style={{ paddingBottom: 0 }}>
          <HomeHeader />
          <ToastContainer />
        </Grid.Row>

        <Grid.Row style={{ padding: 0 }}>
          <Grid.Column
            widescreen={2}
            largeScreen={3}
            computer={3}
            tablet={4}
            mobile={4}
            style={{ padding: "1em", height: "100vh" }}
            verticalAlign="top"
          >
            <div className={`ui tenant logo ${tenantName}`} />

            <HomeMenu />
          </Grid.Column>

          <Grid.Column
            widescreen={14}
            largeScreen={13}
            computer={13}
            tablet={12}
            mobile={12}
            style={{ padding: "1em 0 0 0" }}
          >
            <AppRouting />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({ ...state.common });

const mapDispatchToProps = dispatch => ({
  loadApp: () => dispatch(appLoaded()),
  logOut: () => dispatch(logOut())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
